import React from "react";
import { ProgressBar } from "react-bootstrap";

const ManageStatusBarBlank = () => {
  return (
    <div style={{ width: "100%" }}>
      <div className="progressbar-datanewcard">
        <ProgressBar
          variant={"success"}
          now={0}
          style={{ width: "10%" }}
          key={1}
        />

        <ProgressBar
          variant={"success"}
          now={0}
          style={{ width: "10%" }}
          key={2}
        />

        <ProgressBar
          variant={"success"}
          now={0}
          style={{ width: "60%" }}
          key={3}
        />

        <ProgressBar
          variant={"success"}
          now={0}
          style={{ width: "10%" }}
          key={4}
        />

        <ProgressBar
          variant={"success"}
          now={0}
          style={{ width: "10%" }}
          key={5}
        />
      </div>
    </div>
  );
};

export default ManageStatusBarBlank;
